export default __webpack_public_path__ + "static/media/mastercard-icon.7081562d.svg";